import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MpSnackbarService } from './mp-snackbar.service';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MpSnackbarModel, SnackBarLevel } from './mp-snackbar.model';

@Component({
  selector: 'app-mp-snackbar',
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './mp-snackbar.component.html',
  styleUrls: ['./mp-snackbar.component.scss']
})
export class MpSnackbarComponent implements OnInit {
  protected snackbar: MpSnackbarModel;
  private _destroyRef = inject(DestroyRef);

  constructor(private snackbarService: MpSnackbarService) {}

  ngOnInit() {
    this.snackbarService.getSnackbarSubject()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((subject) => {
        this.snackbar = subject;
      });
  }

  public closeSnackbar() {
    this.snackbarService.closeSnackBar();
  }

  public iconLevel(): string {
    switch (this.snackbar.level) {
      case SnackBarLevel.Error:
        return 'fa-exclamation';
      case SnackBarLevel.Warning:
        return 'fa-triangle-exclamation';
      case SnackBarLevel.Success:
        return 'fa-check';
      default:
        return 'fa-info';
    }
  }
}
